import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './Programs.css';

const Programs = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['कार्यक्रम', 'नाट्य महोत्सव', 'साहित्य संमेलन', 'भजन स्पर्धा', 'लोकनृत्य'],
    en: ['programs', 'theatre festival', 'literature conference', 'bhajan competition', 'folk dance']
  });

  const pageHeaderData = {
    title: {
      marathi: 'कार्यक्रम',
      english: 'Programs'
    },
    subtitle: {
      marathi: 'मंडळाच्या विविध कल्याणकारी कार्यक्रम',
      english: 'Various welfare programs of the board'
    }
  };

  return (
    <div className="programs">
      <div className="programs-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="programs-content">
          {/* Programs Table */}
          <section className="programs-section">
            <div className="programs-table-container">
              <table className="programs-table">
                <thead>
                  <tr>
                    <th>
                      {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
                    </th>
                    <th>
                      {isMarathi() ? 'कार्यक्रम' : 'Program'}
                    </th>
                    <th>
                      {isMarathi() ? 'परिपत्रक' : 'Circular'}
                    </th>
                    <th>
                      {isMarathi() ? 'फॉर्म' : 'Form'}
                    </th>
                    <th>
                      {isMarathi() ? 'दिनांक' : 'Date'}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '१' : '1'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? '१७ वे राज्यस्तरीय कामगार साहित्य संमेलन' : '17th State-Level labours\' Literature Conference'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/kamgar_sahitya_sammelan_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/kamgar_sahitya_sammelan_form.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '२' : '2'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'कामगार नाट्य महोत्सव' : 'Labours\' Theatre Festival'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/kamgar_natya_mahotsav_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/kamgar_natya_mahotsav_form.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '३' : '3'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'महिला नाट्य महोत्सव' : 'Women\'s Theatre Festival'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/mahila_natya_mahotsav_paripatrk.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '४' : '4'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'बाल नाट्य महोत्सव' : 'Children\'s Theatre Festival'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/balnatya_mahotsav_pariptrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '५' : '5'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'दशावतारी नाट्य महोत्सव' : 'Dashavatari Theatre Festival'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/dashavatari_nathy_mahotsav_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '६' : '6'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'नाट्य प्रशिक्षण शिबीर' : 'Theatre Training Camp'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/natya_prashikshan_shibir_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '७' : '7'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'भजन स्पर्धा' : 'Bhajan Competition'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/bhajan_spardha_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '८' : '8'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'लोकनृत्य स्पर्धा' : 'Folk Dance Competition'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/loknrutya_spardha_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '९' : '9'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'समरगीत स्पर्धा' : 'Patriotic Song Competition'}
                    </td>
                    <td className="program-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/programs/samargeet_spardha_paripatrak.pdf" 
                        className="program-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="program-serial">
                      {isMarathi() ? '१०' : '10'}
                    </td>
                    <td className="program-details">
                      {isMarathi() ? 'राज्यस्तरीय भजन प्रशिक्षण शिबीर' : 'State-Level Bhajan Training Camp'}
                    </td>
                    <td className="program-na">NA</td>
                    <td className="program-na">NA</td>
                    <td className="program-date">
                      {isMarathi() ? '-' : '-'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Navigation Buttons */}
          <section className="programs-navigation">
            <div className="navigation-buttons">
              <Link to="/schemes" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'योजना' : 'Schemes'}
              </Link>
              <Link to="/activities" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17ZM17 21V10H13V6H7V19H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'उपक्रम' : 'Activities'}
              </Link>
              <Link to="/awards" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 18C13.1046 18 14 18.8954 14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'पुरस्कार' : 'Awards'}
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Programs;
